const MAX_TIMEOUT_DELAY = 2147483647; // ~24.8 days, the max delay setTimeout supports

class SeasonalNoticeComponent extends HTMLElement {
  connectedCallback() {
    this.startDate = this.dataset.start ? new Date(this.dataset.start) : null;
    this.endDate = this.dataset.end ? new Date(this.dataset.end) : null;

    this.update();
  }

  disconnectedCallback() {
    clearTimeout(this.timeoutId);
  }

  update = () => {
    if (window.Shopify?.designMode) {
      this.hidden = false;
      return;
    }

    const now = new Date();
    const isActive = (!this.startDate || now >= this.startDate) && (!this.endDate || now <= this.endDate);

    this.hidden = !isActive;
    this.scheduleNextUpdate(now);
  };

  scheduleNextUpdate(now) {
    clearTimeout(this.timeoutId);

    let nextChange = null;
    if (this.startDate && now < this.startDate) {
      nextChange = this.startDate;
    } else if (this.endDate && now <= this.endDate) {
      nextChange = new Date(this.endDate.getTime() + 1000);
    }

    if (!nextChange) return;

    const delay = Math.min(nextChange.getTime() - now.getTime(), MAX_TIMEOUT_DELAY);
    this.timeoutId = setTimeout(this.update, Math.max(delay, 0));
  }
}

if (!customElements.get('seasonal-notice-component')) {
  customElements.define('seasonal-notice-component', SeasonalNoticeComponent);
}
